<template>
  <div v-if="yearsToSelect" id="tax-docs-renta">
    <TaxGuideAlert />

    <v-card class="px-5 py-2 mt-4 mb-0 elevation-0">
      <v-chip-group v-model="yearSelected" active-class="primary" mandatory show-arrows>
        <v-chip
          v-for="year in yearsToSelect"
          :key="year"
          filter
          outlined
          :value="year"
          @click="yearClicked(year)"
        >
          {{ $t('views.tax.taxSummary.taxYear') }} {{ year }}
        </v-chip>
      </v-chip-group>
    </v-card>

    <SomePositionIncomplete />

    <BarLoading v-if="loading" />
    <template v-else>
      <v-card v-if="somePendingRecreatePosition" class="pa-4 pt-7 mt-4 elevation-0">
        <TaxSomePositionRecreating />
      </v-card>
      <v-row v-else>
        <v-col cols="12" md="12" class="mt-4 py-0">
          <v-alert
            v-if="yearRenta.status === 'closed'"
            color="softInfo"
            icon="mdi-file-document-remove-outline"
            class="mb-0"
          >
            El plazo para la presentación de la declaración de la renta para el ejercicio
            correspondiente a {{ yearSelected }}, ya ha terminado.
          </v-alert>
          <v-alert
            v-if="yearRenta.status === 'opened'"
            color="softBackgroundGreen"
            icon="mdi-file-document-check-outline"
            class="mb-0"
          >
            El plazo para la presentación de la declaración de la renta para el ejercicio
            correspondiente a {{ yearSelected }}, se encuentra abierto. Puedes acceder al borrador
            para presentar tu declaración.
          </v-alert>
          <v-alert
            v-if="yearRenta.status === 'future'"
            color="softWarning"
            icon="mdi-file-document-remove-outline"
            class="mb-0"
          >
            El plazo para la presentación de la declaración de la renta para el ejercicio
            correspondiente a {{ yearSelected }}, aún no se encuentra abierto.
          </v-alert>
        </v-col>

        <v-col v-if="!yearRenta.confirmed" cols="12" md="12" class="mt-4 py-0">
          <v-alert color="softWarning" icon="mdi-alert" class="mb-0">
            Los número de las casillas aún no han sido confirmados y pueden ser distintos, por no
            coincidir con años anteriores.
          </v-alert>
        </v-col>

        <v-col cols="12" md="12" class="mt-4 py-0">
          <RendCapMob
            :rendCapMob="yearRenta.sections.rendCapMob"
            :yearSelected="yearSelected"
            :hideDataNoPlanUser="hideDataNoPlanUser"
            @updateRenta="updateData"
          />
        </v-col>
        <v-col cols="12" md="12" class="mt-4 py-0">
          <FondosAcciones
            :fondosAcciones="yearRenta.sections.fondosAcciones"
            :yearSelected="yearSelected"
            :hideDataNoPlanUser="hideDataNoPlanUser"
          />
        </v-col>
        <v-col cols="12" md="12" class="mt-4 py-0">
          <GyPPatrimoniales
            :gypPatrimoniales="yearRenta.sections.gypPatrimoniales"
            :yearSelected="yearSelected"
            :hideDataNoPlanUser="hideDataNoPlanUser"
          />
        </v-col>
        <v-col cols="12" md="12" class="mt-4 py-0">
          <IntegracionCompensacion
            :integracionCompensacion="yearRenta.sections.integracionCompensacion"
          />
        </v-col>
        <v-col cols="12" md="12" class="mt-6 py-3">
          <TaxDisclaimer />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { getTaxDoc, getSummary } from '@/lib/api.js'
import taxMixin from '@/views/components/tax/taxMixin'
import RendCapMob from '@/views/components/tax/taxDocs/renta/RendCapMob'
import FondosAcciones from '@/views/components/tax/taxDocs/renta/FondosAcciones'
import GyPPatrimoniales from '@/views/components/tax/taxDocs/renta/GyPPatrimoniales'
import IntegracionCompensacion from '@/views/components/tax/taxDocs/renta/IntegracionCompensacion'

export default {
  components: {
    RendCapMob,
    FondosAcciones,
    GyPPatrimoniales,
    IntegracionCompensacion,
  },
  mixins: [taxMixin],
  data: () => ({
    tab: 'renta',
    yearRenta: {},
  }),
  async mounted() {
    const portfolioAge = await getSummary({
      type: 'portfolio-age',
    })
    this.yearsToSelect = portfolioAge.data
      .filter((elem) => elem >= 2019)
      .map((elem) => {
        return elem.toString()
      })
    if (this.yearsToSelect.length >= 2) {
      this.yearSelected = this.yearsToSelect[this.yearsToSelect.length - 2]
    } else {
      this.yearSelected = this.yearsToSelect[this.yearsToSelect.length - 1]
    }
  },
  methods: {
    async loadData(startDate, endDate) {
      const yearRenta = await getTaxDoc({ doc: 'renta', startDate, endDate })
      this.yearRenta = yearRenta.data
    },
  },
}
</script>
